import Card from "../components/Card"
import CardListaEspera from "../components/card-lista-espera/CardListaEspera"
import Icon from "src/shared/icons"
import Empty from "src/shared/components/data-display/empty/Empty"

interface ListaEsperaItem {
    nombreHabitacion: string
    folios: any[]
}

interface BuildDisponibilidadSlidesProps {
    items: any[][]
    logo: string
}

interface BuildListaEsperaSlidesProps {
    listaEspera: ListaEsperaItem[][] | null
    onListaEsperaTitleClick?: () => void
    showExternalLinkIcon?: boolean
    showEmptyState?: boolean
}

export function buildDisponibilidadSlides({ items, logo }: BuildDisponibilidadSlidesProps): JSX.Element[] {
    return items.map((group, index) => (
        <div className="disp__card-list" key={`group-${index}`}>
            {group.map((item, key) => (
                <Card 
                    key={key} 
                    logo={logo} 
                    image={item.image}
                    disponibles={item.disponibles}
                    title={item.title}
                    hours={item.hours}
                    status={item.status}
                    price={item.price}
                    size={item.size}
                    bed={item.bed}
                    {...item}
                />
            ))}
        </div>
    ))
}

export function buildListaEsperaSlides({ 
    listaEspera, 
    onListaEsperaTitleClick,
    showExternalLinkIcon = false,
    showEmptyState = false,
}: BuildListaEsperaSlidesProps): JSX.Element[] {
    const ListaEsperaTitle = () => (
        <p 
            className={`disp__card-list-title ${showExternalLinkIcon ? 'disp__card-list-title--clickable' : ''}`}
            onClick={onListaEsperaTitleClick}
        >
            Lista de espera para habitaciones
            {showExternalLinkIcon && (
                <Icon 
                    name="ExternalLinkFill" 
                    width={40} 
                    height={40} 
                    color="var(--white)" 
                    style={{ marginLeft: "20px" }} 
                />
            )}
        </p>
    )

    if (!listaEspera || listaEspera.length === 0) {
        if (!showEmptyState) {
            return []
        }
        return [
            <div className="disp__card-list" key="lista-espera-empty">
                <ListaEsperaTitle />
                <div className="disp__card-empty-container">
                    <Empty
                        className="disp__card-empty"
                        theme={"dark"}
                        title={"Lista de espera vacía"}
                        description={
                            "No se han registrado turnos en este momento."
                        }
                        icon={"docFill"}
                    />
                </div>
            </div>
        ]
    }

    return listaEspera.map((group, index) => (
        <div className="disp__card-list" key={`lista-espera-${index}`}>
            <ListaEsperaTitle />
            {group.map((item, key) => (
                <CardListaEspera
                    key={key}
                    nombreHabitacion={item.nombreHabitacion}
                    folios={item.folios}
                />
            ))}
        </div>
    ))
}